var _style, _metadata, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "final_svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "346.80828857421875 143.3369140625 307.3834228515625 216.92489624023438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FFEA92;}\t.st1{fill:#33332E;}\t.st2{fill:#2EFFF9;}\t.st3{opacity:0.21;enable-background:new    ;}\t.st4{fill:url(#SVGID_1_);}\t.st5{fill:url(#SVGID_2_);}\t.st6{fill:none;stroke:url(#SVGID_3_);stroke-miterlimit:10;}\t.st7{fill:none;stroke:url(#SVGID_4_);stroke-miterlimit:10;}")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", null, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("slicesourcebounds", {
    bottomleftorigin: "true",
    height: 222.3,
    width: 315,
    x: 0,
    y: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color_index_2",
    fill: "#ffe98b",
    transform: "translate(346.8082858775126, 143.33691332962962) scale(0.9758204071269049)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.7,163.46l-31.52-55.1V0H92.54v108.36l0,0L60,162.87c-2.14,3.58-3.27,7.67-3.27,11.84h199.41v-0.92 C256.14,170.2,255.31,166.67,253.7,163.46z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "color_index_1_1_",
    transform: "translate(346.8082858775126, 143.33691332962962) scale(0.9758204071269049)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.75,
    y: 4.36,
    width: 119.22,
    height: 99.65
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.26,150.8 144.55,162.13 88.2,162.13 94.74,150.84 80.27,150.8 99.88,114.85 217.66,114.85  234.64,150.8  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "color_index_0",
    fill: "#2efff9",
    transform: "translate(346.8082858775126, 143.33691332962962) scale(0.9758204071269049)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.77,78.9l-9.59-16.54v2.54l5.12,8.84h-5.12V75h5.87l2.82,4.87l7.38,12.72h-16.07v1.27H239L252.39,117 h-25.3l0.73,1.28h25.31l16.06,27.67h-25.53l0.73,1.28h25.54L291.3,184h-40.86l-4.15-9.29h-1.4L249,184h-43.58l-2.32-9.29h-1.32 l2.33,9.29h-46v-9.29h-1.28V184h-46l2.33-9.29h-1.26l-2.32,9.29H66l4.15-9.29h-1.4L64.56,184H23.7l21.37-36.82h24.28l0.76-1.28 h-24.3l16.06-27.67h24.77L87.4,117H62.61L76,93.87h16.54V92.6H76.75l7.38-12.72L87,75h5.59v-1.26H87.7l4.84-8.34v-2.54l-9.31,16 L0,222.3h315L231.77,78.9z M2.22,221L23,185.27h41L48,221H2.22z M49.41,221l16-35.75h43.87l-9,35.75H49.41z M156.86,221h-55.23 l8.94-35.75h46.29V221z M158.14,221v-35.73h46.29l8.94,35.73H158.14z M214.69,221l-8.95-35.75h43.87l16,35.75H214.69z M251,185.27 h41L312.78,221H267L251,185.27z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.8082858775126, 143.33691332962962) scale(0.9758204071269049)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57,171.11c-0.18,1.19-0.28,2.39-0.28,3.6h199.42v-0.92c0-3.59-0.83-7.12-2.44-10.33L57,171.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.76,10.32h-85.68c-5.32,0-9.64,4.32-9.64,9.64c0,0.01,0,0.03,0,0.04v68.41c0.03,5.3,4.34,9.59,9.64,9.59h85.68 c5.32,0,9.63-4.31,9.64-9.63V20c0.02-5.32-4.28-9.66-9.6-9.68C199.79,10.32,199.77,10.32,199.76,10.32z M202.76,81.11 c-0.01,7.37-5.97,13.33-13.34,13.34h-64.97c-7.37,0-13.34-5.97-13.34-13.34V27.25c0-7.37,5.97-13.34,13.34-13.34h64.94 c7.37,0,13.34,5.97,13.34,13.34L202.76,81.11z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "222.18,108.36 92.54,108.36 79.36,130.42 228.1,118.71  "
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.8082858775126, 143.33691332962962) scale(0.9758204071269049)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.355,
    y1: 122.54,
    x2: 157.355,
    y2: 181.97,
    gradientTransform: "matrix(1 0 0 -1 0 224)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE962"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#FFDB64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#FFB669"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FF936D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C16976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#703182"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#3D0E8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#29008D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#24007C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#170051"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#03000B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.355,
    y1: 164.52,
    x2: 157.355,
    y2: 208.97,
    gradientTransform: "matrix(1 0 0 -1 0 224)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#FFB19C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F8B29C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#E6B69E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#C7BCA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#9DC4A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#67CEA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#3FD6AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#39D7B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#2ADAC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#0FE0DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#00E3EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#04DAE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#0EC3E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#1F9CD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#3668C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#4742BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#002294"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.355,
    y1: 167.89,
    x2: 157.355,
    y2: 210.59,
    gradientTransform: "matrix(1 0 0 -1 0 224)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#FFB19C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F8B29E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#E6B6A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C7BCAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#9CC4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#66CFCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#24DCDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#00E3EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#04DAE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#0EC3E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#1F9CD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#3668C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#4742BF"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.355,
    y1: 177.56,
    x2: 157.355,
    y2: 129.05,
    gradientTransform: "matrix(1 0 0 -1 0 224)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE962"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#FFDB64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#FFB669"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FF936D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C16976"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#703182"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#3D0E8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#29008D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#24007C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#170051"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#03000B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192.3,49.47c-4.85,2.46-9,6.18-13.56,9.06s-10.2,4.95-15.46,3.56c-5.44-1.43-9.3-6.18-14.25-8.84 c-5.82-3.13-12.81-3.25-19.35-2.25c-6.25,0.93-12.34,2.69-18.13,5.23V81c0,7.37,5.97,13.34,13.34,13.34l0,0h64.94 c7.36,0,13.33-5.97,13.33-13.33c0,0,0-0.01,0-0.01V46.39C199.38,46.72,195.69,47.77,192.3,49.47z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M189.83,13.86h-64.94c-7.37,0-13.34,5.97-13.34,13.34v29c5.79-2.53,11.88-4.28,18.13-5.2 c6.54-1,13.53-0.9,19.35,2.23c4.95,2.67,8.81,7.41,14.25,8.84c5.26,1.39,10.84-0.67,15.46-3.55s8.71-6.61,13.56-9.06 c3.39-1.71,7.08-2.76,10.86-3.09V27.2C203.16,19.84,197.19,13.87,189.83,13.86z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M203.16,46.44V27.25c0.01-7.36-5.96-13.33-13.32-13.34c0,0-0.01,0-0.01,0h-64.94 c-7.37,0-13.34,5.97-13.34,13.34v28.86"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M111.55,56v25.11c0,7.37,5.97,13.34,13.34,13.34h64.94c7.36-0.01,13.33-5.98,13.33-13.34V46.44"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#33332e",
    id: "text_group",
    transform: "translate(168.20860634650376, 287.7046138106072)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dedcc2152587762d00a8890b8bebce7b.svg";
export { ForwardRef as ReactComponent };